/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { FC, useState } from "react";
import _ from "lodash";
import DownloadLink from "./DownloadLink";
import FileMetadata from "./FileMetadata";
import { IArchive } from "./Archive";
import upArrow from "../../assets/images/icons/up-arrow.svg";
import styles from "./download.module.scss";

interface IProps {
  archives: IArchive[];
  archive: IArchive;
  archiveIndex: number;
  filesDownloading: any;
  regions: any;
  downloadingRegion: any;
  project: "nuScenes" | "nuPlan";
  downloadFile: (
    file: string,
    region: string,
    project: "nuScenes" | "nuPlan"
  ) => Promise<void>;
}

const ArchiveSimple: FC<IProps> = (props: IProps) => {
  const {
    archives,
    archive,
    archiveIndex,
    filesDownloading,
    regions,
    downloadFile,
    project,
  } = props;
  const [count, setCount] = useState<number>(0);

  const toggleSection =
    (path) =>
    (e): void => {
      const section = _.get(archives, path, "");
      if (section) {
        section.isOpen = !section.isOpen;

        // ./Download.tsx uses something similar, but this essentially forces a re-render of the page
        // and usually shouldn't be used because we are using objects in an incorrect way here.
        setCount(count + 1);
      }
    };

  return (
    <div>
      <h3
        title="Click to toggle the content"
        className={styles.subtitle}
        onClick={toggleSection(archiveIndex)}
      >
        {archive.name}
        <img
          src={upArrow}
          alt="expand"
          className={archive.isOpen ? styles.expand : styles.collapsed}
        />
      </h3>
      {archive.isOpen && (
        <div className={styles.files}>
          <p
            className={styles.text + " " + styles.marginTop}
            dangerouslySetInnerHTML={{ __html: archive.description }}
          />
          {archive.subsets.map((a) => (
            <div key={a.name} className={styles.archiveLink}>
              <DownloadLink
                fileName={a.name}
                filePath={a.file_path}
                filesDownloading={filesDownloading}
                regions={regions}
                downloadingRegion={undefined}
                downloadFile={downloadFile}
                project={project}
              />
              <FileMetadata file={a} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ArchiveSimple;
